import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";

import { checkUserSessionAPI } from "utils/auth/api";

import { auth } from "_firebase/index";

import { actions as userActions } from "store/users";
import { actions as organizationActions } from "store/organizations";

import App from "components/App";

const { fetchUserData, userStart, userFail } = userActions;
const { fetchUserOrganization } = organizationActions;

const mapStateToProps = ({ user: { loading, lastActivity, uid: loadedUid }, organization = {} }) => ({
    loading,
    lastActivity,
    loadedUid,
    organization,
});

const mapDispatchToProps = (dispatch) => ({
    checkUserSession: async () => {
        try {
            await dispatch(userStart());

            await checkUserSessionAPI().then(async ({ data }) => {
                const { user, token } = data;
                const { uid = "" } = user;

                await auth.signInWithCustomToken(token);

                await dispatch(fetchUserData(uid)).then(
                    async ({ email, name, company, userMeta: { role, experienceLevel } = {} }) => {
                        Sentry.setUser({
                            name,
                            email,
                            company,
                        });

                        await mixpanel.people.set({
                            $email: email,
                            $name: name,
                            Company: company,
                            Role: role,
                            "Expierience Level": experienceLevel,
                        });

                        mixpanel.identify(uid);
                    }
                );
            });

            return await auth.currentUser;
        } catch ({ response: { data: { error = "" } = {} } = {} }) {
            const isNoSession = Boolean(localStorage.getItem("wasLoggedIn"));

            console.log("No active session", error.message);

            dispatch(userFail(isNoSession ? "Your session has expired. Please log in again." : ""));

            auth.signOut()
                .then(() => console.log("User signed out"))
                .catch(() => console.log("User was not signed out"));

            localStorage.removeItem("wasLoggedIn");
        }
    },
    fetchUserOrganization: (uid, orgId) => dispatch(fetchUserOrganization(uid, orgId)),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(App);
